/* Cart drawer celebrations: confetti + toasts (July 2026)
   Fires once per transition:
   - blue confetti when cart goes empty -> has items (drawer opening)
   - gold confetti when free shipping threshold is reached */
(function () {
  'use strict';
  var COOLDOWN_MS = 5000;
  var lastFired = { blue: 0, gold: 0 };
  var GOLD_COLORS = ['#e8eefc', '#aac4f5', '#7c9ad6', '#3764e4'];

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function panelRect(drawer) {
    // July 2026: confetti + toasts are always centered on the full screen
    return { left: 0, top: 0, width: window.innerWidth, height: window.innerHeight };
  }

  function brandBlueColors() {
    var trip = getComputedStyle(document.body).getPropertyValue('--color-button').trim();
    if (trip) {
      return ['rgb(' + trip + ')', 'rgba(' + trip + ', 0.55)', '#7c9ad6', '#b8c8e8'];
    }
    return ['#1d3fa8', 'rgba(22, 48, 92, 0.55)', '#7c9ad6', '#b8c8e8'];
  }

  function launchConfetti(drawer, colors) {
    if (reducedMotion()) return;
    var rect = panelRect(drawer);
    if (rect.width < 50) return;
    var canvas = document.createElement('canvas');
    canvas.className = 'cart-celebration-canvas';
    var dpr = window.devicePixelRatio || 1;
    canvas.width = Math.round(rect.width * dpr);
    canvas.height = Math.round(rect.height * dpr);
    canvas.style.cssText = 'position:fixed;pointer-events:none;z-index:10001;left:' + rect.left + 'px;top:' + rect.top + 'px;width:' + rect.width + 'px;height:' + rect.height + 'px;';
    document.body.appendChild(canvas);
    var ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);
    var W = rect.width, H = rect.height;
    var parts = [];
    for (var i = 0; i < 55; i++) {
      parts.push({
        x: Math.random() * W,
        y: -12 - Math.random() * H * 0.25,
        w: 3 + Math.random() * 4,
        h: 6 + Math.random() * 5,
        vx: (Math.random() - 0.5) * 1.2,
        vy: 1 + Math.random() * 1.6,
        rot: Math.random() * Math.PI,
        vr: (Math.random() - 0.5) * 0.2,
        color: colors[i % colors.length],
        delay: Math.random() * 30
      });
    }
    var frame = 0, maxFrames = 150;
    function tick() {
      frame++;
      ctx.clearRect(0, 0, W, H);
      var alive = false;
      var fade = frame > maxFrames - 40 ? Math.max(0, (maxFrames - frame) / 40) : 1;
      parts.forEach(function (p) {
        if (frame < p.delay) { alive = true; return; }
        p.x += p.vx + Math.sin((frame + p.delay) / 12) * 0.4;
        p.y += p.vy;
        p.vy += 0.02;
        p.rot += p.vr;
        if (p.y < H + 14) alive = true;
        ctx.save();
        ctx.globalAlpha = 0.9 * fade;
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        ctx.restore();
      });
      if (alive && frame < maxFrames) requestAnimationFrame(tick);
      else canvas.remove();
    }
    requestAnimationFrame(tick);
  }

  function showToast(drawer, text, variant) {
    var rect = panelRect(drawer);
    var offset = document.querySelectorAll('.cart-celebration-toast').length * 44;
    var toast = document.createElement('div');
    toast.className = 'cart-celebration-toast cart-celebration-toast--' + variant;
    toast.textContent = text;
    toast.style.left = (rect.left + rect.width / 2) + 'px';
    toast.style.top = (rect.top + Math.min(rect.height * 0.18, 130) + offset) + 'px';
    document.body.appendChild(toast);
    toast.addEventListener('animationend', function () { toast.remove(); });
    setTimeout(function () { if (toast.parentNode) toast.remove(); }, 4000);
  }

  function celebrate(drawer, variant, text, colors) {
    var now = Date.now();
    if (now - lastFired[variant] < COOLDOWN_MS) return;
    lastFired[variant] = now;
    launchConfetti(drawer, colors);
    showToast(drawer, text, variant);
  }

  function init() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    function isOpen() { return drawer.classList.contains('active'); }
    // Returns true/false, or null when the DOM is mid-render and the state is unknown.
    function readHasItems() {
      if (drawer.querySelector('.cart-item')) return true;
      if (drawer.querySelector('.drawer__inner-empty')) return false;
      return null;
    }
    function readEligible() {
      var bar = drawer.querySelector('.freeshipping-progress [role="progressbar"]');
      if (!bar) return null;
      var v = parseFloat(bar.getAttribute('aria-valuenow'));
      return isNaN(v) ? null : (v >= 0.999);
    }

    var prevHasItems = readHasItems();
    var prevEligible = readEligible();
    var pendingBlue = 0;
    var pendingGold = 0;
    var PENDING_WINDOW_MS = 8000;
    var scheduled = false;

    function check() {
      scheduled = false;
      var open = isOpen();
      var has = readHasItems();
      var eligible = readEligible();

      if (has !== null) {
        if (has === true && prevHasItems === false) pendingBlue = Date.now();
        if (has === false) { pendingBlue = 0; pendingGold = 0; }
        prevHasItems = has;
      }
      if (eligible !== null) {
        if (eligible === true && prevEligible === false) pendingGold = Date.now();
        if (eligible === false) pendingGold = 0;
        prevEligible = eligible;
      }

      if (open && pendingBlue && Date.now() - pendingBlue < PENDING_WINDOW_MS) {
        pendingBlue = 0;
        celebrate(drawer, 'blue', 'יש מוצרים בסל 💙', brandBlueColors());
      }
      if (open && pendingGold && Date.now() - pendingGold < PENDING_WINDOW_MS && prevHasItems) {
        pendingGold = 0;
        celebrate(drawer, 'gold', 'קיבלת משלוח חינם 😀', GOLD_COLORS);
      }
    }

    var mo = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () { setTimeout(check, 120); });
    });
    mo.observe(drawer, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
